export const config = {
  ENVIRONMENT: import.meta.env.VITE_ENVIRONMENT as string,
  BACKEND_URL: import.meta.env.VITE_BACKEND_URL as string,
  SENTRY_DSN: import.meta.env.VITE_SENTRY_DSN as string,
  IMPRINT_URL: import.meta.env.VITE_IMPRINT_URL as string,
};
